// src/components/contacts/DeviceContactPicker.tsx
import React from 'react';
import './DeviceContactPicker.css';
import { useContactPicker, SelectedContact } from '../../hooks/useContactPicker';
import SparkButton from '../common/SparkButton';

// Define the component props interface
interface DeviceContactPickerProps {
  onContactsSelected?: (contacts: SelectedContact[]) => void;
}

const DeviceContactPicker: React.FC<DeviceContactPickerProps> = ({ 
  onContactsSelected 
}) => {
  const { isSupported, pickContacts, selectedContacts, error } = useContactPicker();

  const handlePickContacts = async () => {
    await pickContacts();
    // If contacts were selected and callback provided, execute it
    if (selectedContacts.length > 0 && onContactsSelected) {
      onContactsSelected(selectedContacts);
    }
  };

  if (!isSupported) {
    return <p>Contact Picker API not supported.</p>;
  }

  return (
    <div>
      <SparkButton size="small" onClick={handlePickContacts}>
        SELECT FROM DEVICE CONTACTS
      </SparkButton>
      {error && <p className="error-message">{error.message}</p>}

      {selectedContacts.map((c: SelectedContact, idx: number) => (
        <div key={idx}>
          <strong>{c.name}</strong> ({c.email || 'No email'}, {c.phone || 'No phone'})
        </div>
      ))}
    </div>
  );
};

export default DeviceContactPicker;